import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import * as invoiceAdditionActions from '../../redux/invoiceAdditions/actions';
import ENUMS from '../../enums';

import Pagination2 from '../../components/Pagination2';
import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

import InvoiceAdditionsTable from './Table';
import AddModal from './modals/Add';
import DetailsModal from './modals/Details';
import DeleteModal from './modals/Delete';

class InvoiceAdditions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      itemsPerPage: 20,
      errorText: locales('errors.default'),
      errorFlag: false,
      addModalIsOpen: false,
      detailsModalIsOpen: false,
      deleteModalIsOpen: false,
      selectedId: null
    };
  }

  componentDidMount() {
    this.refreshList();
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    this.setState({ currentPage: currentPage }, this.refreshList);
  };

  closeDetailsModal = () => {
    this.setState(() => ({
      detailsModalIsOpen: false
    }));
  };

  closeDeleteModal = (success = false) => {
    this.setState(() => ({
      deleteModalIsOpen: false
    }));

    if (success) {
      this.setState({ currentPage: 1 }, this.refreshList);
    }
  };

  displayAddModal = e => {
    e.preventDefault();

    this.setState(() => ({ addModalIsOpen: true }));
  };

  closeAddModal = (success = false) => {
    this.setState(() => ({
      addModalIsOpen: false
    }));

    if (success) {
      this.refreshList();
    }
  };

  toggleStatus = (id, isActive) => {
    this.props.actions.toggleStatus(id, !isActive).then(this.refreshList);
  };

  refreshList = () => {
    const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
    this.props.actions.getList(query);
  };

  displayDeleteModal = id => {
    const invoiceAddition = this.props.invoiceAdditionsList.find(x => x.id == id);

    if (invoiceAddition) {
      const selectedId = invoiceAddition.id;
      const selectedTitle = invoiceAddition.title;
      
      this.setState(() => ({
        deleteModalIsOpen: true,
        selectedId,
        selectedTitle
      }));
    }
  };

  render() {
    const { 
      loading, 
      message, 
      failed, 
      error, 
      toggleStatusLoading,
      toggleStatusFailed,
      toggleStatusError,
      toggleStatusMessage,
      invoiceAdditionsList,
      totalRecords
    } = this.props;

    return (
      <Spin spinning={loading || toggleStatusLoading}>
        <section className="page-header">
          <h1>{locales('titles.cafeAdditionals', { fieldName: this.props.cafeName })}</h1>
          <div className="form-actions">
            <Link to="/deleted-invoice-additions">
              <button className="btn btn-secondary w-5 mx-1">
                <i className="fa fa-times" />
                {locales('labels.deleteds')}
              </button>
            </Link>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_FACTOR_ADDITION}>
              <button
                onClick={this.displayAddModal}
                className="btn btn-primary w-5 mx-1"
              >
                <i className="fal fa-plus mx-1" />
                {locales('labels.new')}
              </button>
            </ShowForPermission>
          </div>
        </section>

        {this.state.errorFlag && this.handleAlert()}
       
        <section className="panel panel-default">
          {error || toggleStatusError ? (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          ) : (
            <>
              {failed && <div className="alert alert-danger">{message}</div>}
              {toggleStatusFailed && <div className="alert alert-danger">{toggleStatusMessage}</div>}
              
              <div className="panel-heading">
                <i className="fas fa-list-alt px-1" />
                {locales('titles.invoice.additions.list', { cafeName: this.props.cafeName })}
              </div>

              <div className="panel-body">
                <InvoiceAdditionsTable 
                  pageNumber={this.state.currentPage} 
                  pageSize={this.state.itemsPerPage}
                  additionalsList={invoiceAdditionsList}
                  loading={this.props.loading}
                  message={this.props.message}
                  failed={this.props.failed}
                  error={this.props.error}

                  toggleStatus={this.toggleStatus}
                  displayDeleteModal={this.displayDeleteModal}
                />
                
                <div className="pagination-container">
                  <Pagination2
                    currentPage={this.state.currentPage}
                    pageLimit={this.state.itemsPerPage}
                    totalRecords={totalRecords}
                    pageNeighbours={2}
                    onPageChanged={this.onPageChanged}
                  />
                </div>
              </div>
            </>
          )}
        </section>

        {this.state.addModalIsOpen && (
          <AddModal
            isOpen={this.state.addModalIsOpen}
            close={this.closeAddModal}
          />
        )}

        {this.state.detailsModalIsOpen && (
          <DetailsModal
            isOpen={this.state.detailsModalIsOpen}
            close={this.closeDetailsModal}
          />
        )}

        {this.state.deleteModalIsOpen && (
          <DeleteModal
            isOpen={this.state.deleteModalIsOpen}
            id={this.state.selectedId}
            title={this.state.selectedTitle}
            close={this.closeDeleteModal}
          />
        )}
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeName: state.authReducer.meInfo.selectedRole.cafeName,
    loading: state.invoiceAdditionsReducer.getInvoiceAdditionsListLoading,
    message: state.invoiceAdditionsReducer.getInvoiceAdditionsListMessage,
    failed: state.invoiceAdditionsReducer.getInvoiceAdditionsListFailed,
    error: state.invoiceAdditionsReducer.getInvoiceAdditionsListError,
    invoiceAdditionsList: state.invoiceAdditionsReducer.invoiceAdditionsList,
    totalRecords: state.invoiceAdditionsReducer.invoiceAdditionsListTotalRecords,

    toggleStatusLoading: state.invoiceAdditionsReducer.toggleInvoiceAdditionStatusLoading,
    toggleStatusFailed: state.invoiceAdditionsReducer.toggleInvoiceAdditionStatusFailed,
    toggleStatusError: state.invoiceAdditionsReducer.toggleInvoiceAdditionStatusError,
    toggleStatusMessage: state.invoiceAdditionsReducer.toggleInvoiceAdditionStatusMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      toggleStatus: (id, isActive) => dispatch(invoiceAdditionActions.toggleStatus(id, isActive)),
      getList: query => dispatch(invoiceAdditionActions.getList(query))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceAdditions);
